import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { GlobalConstants } from '../../constants/global.constant';
import { QrCodeService } from '../../../core/services/qr-input-service/qr-input.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { GoogleAnalyticsService } from 'src/app/core/services/google-analytics-service/google-analytics.service';
import { LibraryV2DataService } from 'src/app/core/services/library-v2/library-v2-data.service';
import { ProcessorService } from 'src/app/modules/details-page/services/processor/processor.service';

@Component({
  selector: 'app-processor-page',
  templateUrl: './processor-page.component.html',
  styleUrls: ['./processor-page.component.css']
})
export class ProcessorPageComponent implements OnInit {
  @Input() panelData: any;
  ptlPanel = GlobalConstants.PTL_TILE_PANEL;
  isWhiteText= ['ptl_aiExperience', 'ptl_gaming', 'ptl_compatibility'];
  isPtl12Xe: boolean = false;
  setFontIntelDisplayOne: boolean;
  ptlGamingPanel1: string = '';
  ptlGamingPanel2: string = '';
  ptlGamingPanel3: string = '';
  ptlGamingPanel4: string = '';
  ptlGamingPanel5: string = '';
  nonItalicLangArray = ['ar-sa','he','ja','ko','th','zh-cn','zh-tw'];
  language: string;
  rtlLangs = ['ar-sa', 'he'];
  private modalOption: NgbModalOptions = {};
  private touchStartX = 0;
  isWildcatLake: boolean = false;
  processorPageData: any;
  wclPanel1BgUrl: string = '';
  wclBgImgUrl: string = 'assets/images/Processor_bg.png';
  wclBgClrImgUrl: string = 'assets/images/badges/badge_background.png'
  longLangWclChips = ['de','el','es','es-mx','fi','fr','is','it','ja','ko','nb','nl','pl','pt-br','pt','ru','uk','vi'];
  heightLang12xePopup=['tr','it','el','hu','uk','ru'];
  constructor(private libraryService: LibraryV2DataService,
    private qrService: QrCodeService,
    private modalService: NgbModal,
    private googleAnalyticsService: GoogleAnalyticsService,
    private processorService: ProcessorService
  ) { }

  ngOnInit(): void {
    this.isPtl12Xe = GlobalConstants.PANTHER_LAKE_12XE_BADGES.includes(this.qrService.qrInput.ProcessorBadge);
    this.setFontIntelDisplayOne = this.qrService.setenusLang();
    this.ptlGamingPanel1 = GlobalConstants.PTL_GAMING_TILE_PANEL1;
    this.ptlGamingPanel2 = GlobalConstants.PTL_GAMING_TILE_PANEL2;
    this.ptlGamingPanel3 = GlobalConstants.PTL_GAMING_TILE_PANEL3;
    this.ptlGamingPanel4 = GlobalConstants.PTL_GAMING_TILE_PANEL4;
    this.ptlGamingPanel5 = GlobalConstants.PTL_GAMING_TILE_PANEL5;
    const qrData = this.qrService?.getQrData();
    this.language = qrData.Language;
    this.isWildcatLake = this.qrService.isWildCatLakeStd;
    this.preloadModalContent();
  }

  whiteText(imgUrl: string): string {
    return this.isWhiteText.some(word => imgUrl.includes(word)) ? 'white_color' : '';
  }

  videoLoaded:boolean = false;
  selectedTileDetail: any;
  selectedTileTitle: string;
  posterPath: any;

  private preloadModalContent(): void {
  if (!this.panelData) {
    return;
  } 
  this.panelData.forEach(panel => {
    if (!panel.titleArray) {
      return;
    } 
    panel.titleArray.forEach(item => {
      const detail = item?.SubSpecs?.[0];
      if (detail?.bgVideoUrl) {
        const video = document.createElement('video');
        video.src = detail.bgVideoUrl;
        video.preload = 'auto';
        video.muted = true;
        video.load();
      }
    });
  });
 }

 openTileModal(content: any, item: any,) {
  const detail = item?.SubSpecs?.[0];
  this.selectedTileTitle = item.title;
  const posterMapping = this.isPtl12Xe ? GlobalConstants.PTL_12XE_VIDEO_POPUP_POSTER_MAPPINGS : GlobalConstants.PTL_STD_VIDEO_POPUP_POSTER_MAPPINGS;
  this.posterPath = posterMapping[this.selectedTileTitle]

  if (!detail) return;

  this.selectedTileDetail = detail;
  this.videoLoaded = false;

  this.modalService.open(content, {
    centered: true,
    backdrop: 'static',
    windowClass: 'std_12xe_proc_ddp_popup'
  });
  this.googleAnalyticsService.procDdpAnalytics(this.selectedTileTitle);
 }

  onVideoLoaded(){
    this.videoLoaded = true;
  }
  closeModel() {
    this.modalService.dismissAll();
  }
  
  openPTLGamingLegalModal(legalModal: TemplateRef<any>) {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalOption.centered = true;
    this.modalOption.windowClass = 'ptl-gaming-legal-and-disclamiers-popup'
    this.modalService.open(legalModal, this.modalOption);
  }

  closePTLGamingLegalModal() {
    this.modalService.dismissAll()
  }
// touch events for carousel starts
  onTouchStart(e: TouchEvent) {
    this.touchStartX = e.touches[0].clientX;
  }
  onTouchEnd(e: TouchEvent, carousel: NgbCarousel) {
    const diff = this.touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? carousel.next() : carousel.prev();
    }
  }
// touch events for carousel ends

  setFont() {
    return this.qrService.setFont();
  }
}
